var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-md-none row mt-3" }, [
      _c("div", { staticClass: "col-12 p-0" }, [
        _c(
          "div",
          {
            staticClass: "px-0 text-center",
            class: _vm.mobileBackgroundClass,
            style: _vm.mobileBackgroundStyle,
          },
          [
            _vm.isIllustrationPresent
              ? _c("picture", [
                  _c("source", {
                    attrs: {
                      media: "(min-width: 480px)",
                      srcset: _vm.smallImageUrl || "",
                    },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "img-fluid my-n1",
                    attrs: {
                      src: _vm.xsImageUrl || "",
                      alt: _vm.imageAlt || "",
                    },
                  }),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "my-n3 my-sm-n5 mb-1 mx-2 popcorn-text-tile bg-gray2",
          },
          [
            _c("div", { staticClass: "px-1 align-self-center bold" }, [
              _c("h3", {
                staticClass: "mb-0 pt-1",
                domProps: { textContent: _vm._s(_vm.title) },
              }),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "list mb-0" },
                _vm._l(_vm.details, function (detail, index) {
                  return _c(
                    "li",
                    { key: index, staticClass: "mb-1" },
                    [
                      _c("span", {
                        directives: [
                          {
                            name: "safe-html",
                            rawName: "v-safe-html",
                            value: detail.descriptionBbcode,
                            expression: "detail.descriptionBbcode",
                          },
                        ],
                      }),
                      _vm._v(" "),
                      _vm._l(detail.links, function (link, linkIndex) {
                        return [
                          _c("span", {
                            directives: [
                              {
                                name: "safe-html",
                                rawName: "v-safe-html",
                                value: link,
                                expression: "link",
                              },
                            ],
                            key: "link-" + linkIndex,
                          }),
                        ]
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-none d-md-block mt-3 mx-1" }, [
      _c(
        "div",
        {
          staticClass: "row",
          class: _vm.desktopBackgroundClass,
          style: _vm.desktopBackgroundStyle,
        },
        [
          _c("div", { staticClass: "col-5 col-xl-4 px-0 d-flex" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-7 col-xl-8 px-0", class: _vm.contentClass },
            [
              _c("div", { staticClass: "ps-1 align-self-center bg-gray2" }, [
                _c("h3", {
                  staticClass: "mb-0 pt-1",
                  domProps: { textContent: _vm._s(_vm.title) },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list mb-0 ps-1 pe-md-1" },
                  _vm._l(_vm.details, function (detail, index) {
                    return _c(
                      "li",
                      { key: index },
                      [
                        _c("span", {
                          directives: [
                            {
                              name: "safe-html",
                              rawName: "v-safe-html",
                              value: detail.descriptionBbcode,
                              expression: "detail.descriptionBbcode",
                            },
                          ],
                        }),
                        _vm._v(" "),
                        _vm._l(detail.links, function (link, linkIndex) {
                          return [
                            _c("span", {
                              directives: [
                                {
                                  name: "safe-html",
                                  rawName: "v-safe-html",
                                  value: link,
                                  expression: "link",
                                },
                              ],
                              key: "link-" + linkIndex,
                            }),
                          ]
                        }),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }